import { CalendarEventModule } from "@/store/modules/calendarEvent.modules";
import { Machine, assign } from "xstate";
import { toaster } from "@/utilities/toaster";
const calendarEventMachine = Machine({
    id: "calendarEvent",
    context: {
        searchData: {
            page: 1,
            pageSize: 10,
            sort: {
                field: "dueDate",
                type: "none",
            },
            columnFilters: [],
        },
        ispageChanged: false,
    },
    initial: "idle",
    states: {
        idle: {
            on: {
                GETTING_CALENDAR_EVENT: { target: "gettingCalendarEvents", actions: "assignSearchData" },
            },
        },
        gettingCalendarEvents: {
            invoke: {
                id: "gettingCalendarEvents",
                src: (context, event) => {
                    return CalendarEventModule.GetCalendarEvents(context.searchData);
                },
                onDone: { target: "loadedCalendarEvents" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedCalendarEvents: {
            on: {
                GETTING_CALENDAR_EVENT: { target: "gettingCalendarEvents", actions: "assignSearchData" },
                DELETE_CALENDAR_EVENT: { target: "deleteCalendarEvent", actions: "ispageChanged" },
                CANCEL: { target: "cancelCalenderEvents" },
            },
        },
        deleteCalendarEvent: {
            tags: "showCalendarDelete",
            on: {
                DELETING_CALENDAR_EVENT: { target: "deletingCalendarEvent" },
                CANCEL: { target: "cancelCalenderEvents" },
            },
        },
        deletingCalendarEvent: {
            tags: "showCalendarDelete",
            invoke: {
                id: "deletingCalendarEvent",
                src: (context, event) => {
                    return CalendarEventModule.DeleteCalendarEvent(event.eventId);
                },
                onDone: { target: "gettingCalendarEvents", actions: ["showSuccessMessage", "setPage"] },
                onError: { target: "serviceUnavailable" },
            },
        },
        cancelCalenderEvents: {
            on: {
                CANCEL: { target: "loadedCalendarEvents" },
                DELETE_CALENDAR_EVENT: { target: "deleteCalendarEvent" },
            },
        },
        serviceUnavailable: {
            type: "final",
        },
    },
}, {
    actions: {
        assignSearchData: assign({
            searchData: (context, event) => event.searchData,
        }),
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
        setPage: assign({
            searchData: (context, event) => {
                if (context.ispageChanged) {
                    const updatedSearchData = {
                        ...context.searchData,
                        page: context.searchData.page - 1,
                    };
                    CalendarEventModule.AssignSearchParams(updatedSearchData);
                    return updatedSearchData;
                }
                return context.searchData;
            },
        }),
        ispageChanged: assign({
            ispageChanged: (context, event) => event.ispageChanged,
        }),
    },
    guards: {},
    activities: {},
    services: {},
});
export default calendarEventMachine;
